export const SortingOptions = {
  Metadata: {
    distanceToGCP: 'Distance to GCP',
  },
  Name: {
    ASC: 'A - Z',
    DESC: 'Z - A',
  },
};
